"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toDecimalString = exports.toDecimal = void 0;
var toDecimal = exports.toDecimal = function toDecimal(value) {
  return Math.round(value * 100) / 100;
};
var toDecimalString = exports.toDecimalString = function toDecimalString(value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return toDecimal(value).toFixed(precision);
};